import { defineStore } from 'pinia';

export const useDialogsStore = defineStore('dialogs', {
  state: () => ({
    openDialog1: null as null | {
      module: string,
      id: number,
      props?: Record<string, any>,
      open: boolean
    },
    openDialog2: null as null | {
      module: string,
      id: number,
      props?: Record<string, any>,
      open: boolean
    },
    openDialog3: null as null | {
      module: string,
      id: number,
      props?: Record<string, any>,
      open: boolean
    }
  }),
  actions: {
    open(module: string, id: number, props = {}) {
      // Si ya está abierto en alguno de los dos, NO hagas nada
      if (
        (this.openDialog1 && this.openDialog1.module === module && this.openDialog1.id === id && this.openDialog1.open) ||
        (this.openDialog2 && this.openDialog2.module === module && this.openDialog2.id === id && this.openDialog2.open) ||
        (this.openDialog3 && this.openDialog3.module === module && this.openDialog3.id === id && this.openDialog3.open)
      ) {
        return;
      }
      // Resto de lógica igual...
      if (!this.openDialog1) {
        this.openDialog1 = { module, id, props, open: true };
      }
      else if (this.openDialog1.module === module && this.openDialog1.id === id) {
        this.openDialog1.open = true;
        this.openDialog1.props = props;
      }
      else if (!this.openDialog2) {
        this.openDialog2 = { module, id, props, open: true };
      }
      else if (this.openDialog2.module === module && this.openDialog2.id === id) {
        this.openDialog2.open = true;
        this.openDialog2.props = props;
      }
      else if (!this.openDialog3) {
        this.openDialog3 = { module, id, props, open: true };
      }
      else if (this.openDialog3.module === module && this.openDialog3.id === id) {
        this.openDialog3.open = true;
        this.openDialog3.props = props;
      }
      else {
        this.openDialog3 = { module, id, props, open: true };
      }
    },
    close() {
      if (this.openDialog3) {
        this.openDialog3 = null;
      }
      else if (this.openDialog2) {
        this.openDialog2 = null;
      } else if (this.openDialog1) {
        this.openDialog1 = null;
      }
    },
    closeBy(module: string, id: number) {
      if (this.openDialog3 && this.openDialog3.module === module && this.openDialog3.id === id) {
        this.openDialog3 = null;
      }else if (this.openDialog2 && this.openDialog2.module === module && this.openDialog2.id === id) {
        this.openDialog2 = null;
      } else if (this.openDialog1 && this.openDialog1.module === module && this.openDialog1.id === id) {
        this.openDialog1 = null;
      }
    },
    closeAll() {
      this.openDialog1 = null;
      this.openDialog2 = null;
      this.openDialog3 = null;
    }
  },
  persist: true
});
